import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { useLocation } from "react-router-dom";
import { getSubActivity } from '../../../helper/Api';
import { FaRegEdit } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Card, CardContent, Chip } from '@mui/material';
import '../Multi-Department/ManageDepartment.css';

const SubactivityList = (filterDate) => {
    const { authData } = useSelector((state) => state.authData);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    let { state } = useLocation();
    const [data, setData] = useState(state && state.data ? state.data : []);

    const customStyles = {
        table: {
            style: {
                width: "100%",
                tableLayout: "fixed",
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
        cells: {
            style: {
                wordBreak: "break-word",
            },
        },
    };

    const showEditColumn =
        authData.user.department_id === "1" && authData.user.user_type === "l3";

    const columns = [
        {
            name: 'Id',
            selector: (row) => row.id,
            sortable: true,
            width: showEditColumn ? "8%" : "10%",
            minWidth: "72px",
        },
        {
            name: 'Activity',
            selector: (row) => row.activity,
            sortable: true,
            width: showEditColumn ? "24%" : "30%",
            wrap: true,
            right: false
        },
        {
            name: 'Subactivity',
            selector: (row) => row.subactivity,
            sortable: true,
            width: showEditColumn ? "26%" : "35%",
            wrap: true,
            right: false
        },
        {
            name: 'Status',
            selector: (row) =>
            row.status === "1" ? (
                <Chip label="Active" color="success" size="small" />
            ) : (
                <Chip label="Inactive" color="error" size="small" />
            ),
            sortable: true,
            width: showEditColumn ? "16%" : "25%",
            right: false
        },
    ];

    if (showEditColumn) {
        columns.push({
            name: 'Edit / Update',
            width: "24%",
            minWidth: "96px",
            allowOverflow: true,
            style: { overflow: 'visible' },
            selector: (row) =>
                authData.user.user_type === 'l3' ? (
                    <div className="user_action" style={{ justifyContent: 'center' }}>
                        <span className="pr-4">
                            <Link
                                to={`/department/edit-subactivity/${row.id}`}
                                className="text-decoration-none"
                                style={{ color: '#000' }}
                                title="Edit subactivity"
                            >
                                <FaRegEdit />
                            </Link>
                        </span>
                    </div>
                ) : null,
            center: true,
            sortable: false,
            ignoreRowClick: true,
            button: true,
        });
    }

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    const fetchSubActivity = async () => {
        try {
            const resp = await getSubActivity({
                searchStr: filterDate.searchStr
            });
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }

    useEffect(() => {
        fetchSubActivity();
    }, [filterDate.searchStr])

    return (
        <Card>
            <CardContent>
                <DataTable
                    customStyles={customStyles}
                    className="dataTables_wrapper"
                    columns={columns}
                    data={data}
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="600px"
                    pagination
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={data.length}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </CardContent>
        </Card>
    )
}

export default SubactivityList
